import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';

const ChargeConfigurationModal = ({ isOpen, onClose, roomTypeData, onSave }) => {
  const [frequency, setFrequency] = useState('day');
  const [fullDayThreshold, setFullDayThreshold] = useState('12 hours');
  const [halfDayEnabled, setHalfDayEnabled] = useState(true);
  const [halfDayThreshold, setHalfDayThreshold] = useState('3 hours');

  useEffect(() => {
    if (roomTypeData) {
      const r = roomTypeData.rules || {};
      setFrequency(r.frequency || 'day');
      setFullDayThreshold(r.fullDayThreshold || '12 hours');
      setHalfDayEnabled(r.halfDayEnabled !== false);
      setHalfDayThreshold(r.halfDayThreshold || '3 hours');
    }
  }, [roomTypeData, isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(roomTypeData.roomType, {
      frequency,
      fullDayThreshold,
      halfDayEnabled,
      halfDayThreshold
    });
    toast.success(`Charge configuration for "${roomTypeData.roomType}" saved.`);
    onClose();
  };

  return (
    <div className="manage-modal-backdrop" onClick={onClose}>
      <div
        className="manage-modal-card"
        style={{ maxWidth: '540px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="manage-modal-header">
          <h3>Charge Configuration - {roomTypeData?.roomType}</h3>
          <button className="manage-modal-close" onClick={onClose} title="Close">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="manage-modal-body" style={{ gap: '20px', padding: '24px' }}>
            {/* Charge Frequency */}
            <div className="modal-form-group">
              <label style={{ fontWeight: '700', color: '#0f172a', fontSize: '14px' }}>
                Charge frequency
              </label>
              <select
                value={frequency}
                onChange={(e) => setFrequency(e.target.value)}
                style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
              >
                <option value="day">day</option>
                <option value="hour">hour</option>
                <option value="session">session</option>
                <option value="month">month</option>
              </select>
            </div>

            {/* Charge Threshold Time */}
            <div className="modal-form-group">
              <label style={{ fontWeight: '700', color: '#0f172a', fontSize: '14px' }}>
                Charge threshold time
              </label>
              <select
                value={fullDayThreshold}
                onChange={(e) => setFullDayThreshold(e.target.value)}
                style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
              >
                <option value="12 hours">12 hours</option>
                <option value="6 hours">6 hours</option>
                <option value="8 hours">8 hours</option>
                <option value="18 hours">18 hours</option>
                <option value="24 hours">24 hours</option>
              </select>
            </div>

            {/* Half Day Configuration */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginTop: '6px' }}>
              <button
                type="button"
                onClick={() => setHalfDayEnabled(!halfDayEnabled)}
                style={{
                  background: halfDayEnabled ? '#e11d48' : '#16a34a',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 18px',
                  fontWeight: '600',
                  fontSize: '13px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: halfDayEnabled
                    ? '0 2px 8px rgba(225, 29, 72, 0.25)'
                    : '0 2px 8px rgba(22, 163, 74, 0.25)'
                }}
              >
                {halfDayEnabled ? 'Deactivate halfday charges' : 'Activate halfday charges'}
              </button>

              {halfDayEnabled && (
                <select
                  value={halfDayThreshold}
                  onChange={(e) => setHalfDayThreshold(e.target.value)}
                  style={{
                    padding: '9px 14px',
                    borderRadius: '8px',
                    border: '1px solid #cbd5e1',
                    fontSize: '13.5px',
                    flex: 1
                  }}
                >
                  <option value="3 hours">3 hours</option>
                  <option value="2 hours">2 hours</option>
                  <option value="4 hours">4 hours</option>
                  <option value="6 hours">6 hours</option>
                </select>
              )}
            </div>
          </div>

          <div className="manage-modal-footer" style={{ padding: '16px 24px', gap: '12px' }}>
            <button
              type="button"
              className="modal-btn-cancel"
              onClick={onClose}
              style={{
                background: '#e11d48',
                color: '#ffffff',
                border: 'none',
                padding: '9px 20px',
                fontWeight: '700',
                borderRadius: '8px'
              }}
            >
              cancel
            </button>
            <button
              type="submit"
              className="modal-btn-save"
              style={{
                background: '#2563eb',
                color: '#ffffff',
                border: 'none',
                padding: '9px 24px',
                fontWeight: '700',
                borderRadius: '8px'
              }}
            >
              save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChargeConfigurationModal;
